<template>
	<v-autocomplete
		v-model="mValue"
		:items="filterSelection"
		:item-value="value_key"
		:item-text="text_key"
		hide-details
		dense
		:outlined="outline"
		:placeholder="handlePlaceholder"
		:label="handleLabel"
		:clearable="clearable"
		:virtual-scroll-items="100"
		@keydown.prevent.enter
		@focus="$emit('focus')"
		:class="classname"
		@change="onChange"
		@mouseenter="$emit('mouseenter')"
		:disabled="is_view == 1"
		:chips="multiple"
		:small-chips="multiple"
		:multiple="multiple"
		:deletable-chips="multiple"
		:loading="loading"
		@update:search-input="onSearchInput"
		:hide-no-data="enable_search"
		:menu-props="{ contentClass: 'autocomplete-menu' }"
	>
		<template v-slot:prepend-item v-if="multiple && select_all && !$CoreSettingsJs.emptyObjectValidation(selection)">
			<v-list-item ripple @click="toggleSelectAll" :class="{ 'select-all-item': true, active: isSomeSelected || isAllSelected }">
				<v-list-item-action>
					<v-checkbox :input-value="isAllSelected" :indeterminate="isSomeSelected" color="primary" hide-details></v-checkbox>
				</v-list-item-action>
				<v-list-item-content>
					<v-list-item-title class="font-weight-medium" style="font-size: 14px">
						<span v-text="$t('COMMON.TXT_ALL')"></span>
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-divider class="mt-2 mb-2"></v-divider>
		</template>

		<template v-slot:selection="{ item }" v-if="field_type == 'instructionTypeField'">
			<div v-if="item.id != null" class="d-flex w-100 instructionTypeSelected" style="font-size: 12px">
				<div class="flex-grow-1" v-text="item.name"></div>
				<div :style="$CoreSettingsJs.colorIndicatorStyle(item.color_indicator, $CoreSettingsJs.textColor(item.color_indicator), 2)" v-text="item.color_indicator"></div>
			</div>
			<span v-if="item.id == null" v-text="item.name"></span>
		</template>
		<template v-slot:item="data" v-if="custom_selection == 1">
			<v-list-item
				:disabled="wms == 0 && ['marking', 'delivery_address'].includes(field_type) && typeof data.item[status_key] != 'undefined' && status(data.item) == 3 ? true : false"
				v-on="data.on"
				v-bind="data.attrs"
				v-show="show(data.item)"
				#default="{ active }"
			>
				<v-list-item-action v-if="multiple">
					<v-checkbox :input-value="active"></v-checkbox>
				</v-list-item-action>
				<vListContent
					:item="data.item"
					:field_type="field_type"
					:text_key="text_key"
					:status_key="status_key"
					:tooltip_required="tooltip_required"
					:customer="customer"
					:tooltip_key="tooltip_key"
					:value_key="value_key"
				></vListContent>
			</v-list-item>
		</template>
	</v-autocomplete>
</template>

<style>
	.v-autocomplete.v-text-field--outlined legend {
		width: 0 !important;
	}
</style>

<script>
	import vListContent from "@shared/src/components/vListContent.vue";
	export default {
		computed: {
			mValue: {
				get() {
					return this.data;
				},
				set(newVal) {
					this.$emit("update", newVal);
				},
			},
			handlePlaceholder() {
				return !this.hideLabel ? (this.show_all_label ? this.$t("COMMON.TXT_ALL") : this.placeholder) : "";
			},
			handleLabel() {
				return this.multiple && !this.hideLabel ? (this.show_all_label ? this.$t("COMMON.TXT_ALL") : this.label) : "";
			},
			isAllSelected() {
				if (!this.multiple || !this.select_all || this.$CoreSettingsJs.emptyObjectValidation(this.selection)) return false;
				return this.$CoreSettingsJs.countObjLen(this.mValue) > 0 ? true : false;
			},
			isSomeSelected() {
				if (!this.multiple || !this.select_all || this.$CoreSettingsJs.emptyObjectValidation(this.selection)) return false;
				const allValues = this.selection.filter((item) => this.show(item)).map((item) => item[this.value_key]);
				const selected = this.$CoreSettingsJs.countObjLen(allValues) != this.$CoreSettingsJs.countObjLen(this.mValue) && this.$CoreSettingsJs.countObjLen(this.mValue) > 0;
				return selected ? true : false;
			},
			filterSelection() {
				return !this.$CoreSettingsJs.emptyObjectValidation(this.selection) ? this.selection.filter((item) => this.show(item)) : this.selection;
			},
		},
		components: {
			vListContent,
		},
		props: {
			data: null,
			clearable: {
				type: Boolean,
				default() {
					return false;
				},
			},
			selection: null,
			value_key: {
				type: String,
				default() {
					return "id";
				},
			},
			text_key: {
				type: String,
				default() {
					return "name";
				},
			},
			status_key: {
				type: String,
				default() {
					return "status";
				},
			},
			classname: null,
			custom_selection: {
				type: Number,
				default() {
					return 0;
				},
			},
			field_type: {
				type: String,
				default() {
					return null;
				},
			},
			is_view: {
				type: Number,
				default() {
					return 0;
				},
			},
			multiple: {
				type: Boolean,
				default() {
					return false;
				},
			},
			tooltip_required: {
				type: Number,
				default() {
					return 0;
				},
			},
			tooltip_key: {
				type: String,
				default() {
					return null;
				},
			},
			customer: {
				type: Number,
				default() {
					return 0;
				},
			},
			wms: {
				type: Number,
				default() {
					return 0;
				},
			},
			loading: {
				type: Boolean,
				default() {
					return false;
				},
			},
			enable_search: {
				type: Boolean,
				default() {
					return false;
				},
			},
			placeholder: {
				type: String,
				default() {
					return this.$t("COMMON.SELECTION_OPTION_TITLE");
				},
			},
			label: {
				type: String,
				default() {
					return this.$t("COMMON.SELECTION_OPTION_TITLE");
				},
			},
			hideLabel: {
				type: Boolean,
				default() {
					return false;
				},
			},
			filter_val: {
				type: Object,
				default() {
					return {};
				},
			},
			outline: {
				type: Boolean,
				default() {
					return true;
				},
			},
			show_all_label: {
				type: Boolean,
				default() {
					return false;
				},
			},
			ignore_value: null,
			skip_display: {
				type: Object,
				default() {
					return null;
				},
			},
			inc_inactive: {
				type: Boolean,
				default() {
					return false;
				},
			},
			select_all: {
				type: Boolean,
				default() {
					return false;
				},
			},
			form: {
				type: Object,
				default() {
					return null;
				},
			},
		},
		watch: {
			searchInput(val) {
				if (this.enable_search) {
					clearTimeout(this.timer);

					this.timer = setTimeout(() => {
						this.$emit("search", val, this.form);
					}, 500);
				}
			},
		},
		data() {
			return {
				searchInput: null,
				// isAllSelected: false
			};
		},
		methods: {
			onSearchInput(val) {
				if (val == null) return;
				if (this.enable_search) {
					clearTimeout(this.timer);
					this.timer = setTimeout(() => this.$emit("search", val, this.form), 500);
				}
			},
			onChange() {
				this.$emit("change");
				setTimeout(() => {
					if (this.searchInput !== "") this.searchInput = "";
				}, 0);
			},
			toggleSelectAll() {
				if (this.multiple && this.select_all) {
					if (this.isAllSelected) {
						// Deselect all
						this.mValue = [];
					} else {
						// Select all available items
						const allValues = this.selection.filter((item) => this.show(item)).map((item) => item[this.value_key]);
						this.mValue = [...allValues];
					}
				}
			},
			show(item) {
				if (this.field_type == "wms_ref_id") {
					return (!this.$CoreSettingsJs.emptyObjectValidation(this.data) && this.data == item[this.value_key]) ||
						(parseInt(item.loaded) == this.filter_val.loaded &&
							parseInt(item.loading_status) == this.filter_val.loading_status &&
							((this.inc_inactive && parseInt(item[this.status_key]) == 0) || parseInt(item[this.status_key]) == 1))
						? true
						: false;
				} else if (this.field_type == "epo_wh") {
					return (this.$CoreSettingsJs.emptyObjectValidation(item["block_create_epo"], 1) &&
						(!this.$CoreSettingsJs.emptyObjectValidation(item[this.status_key]) ||
							(this.inc_inactive && parseInt(item[this.status_key]) == 0) ||
							(parseInt(item[this.status_key]) != 0 && parseInt(item[this.status_key]) != 2))) ||
						(!this.$CoreSettingsJs.emptyObjectValidation(this.data) &&
							((typeof this.data == "object" && this.data.includes(item[this.value_key])) || (typeof this.data != "object" && this.data == item[this.value_key])))
						? true
						: false;
				} else if (this.field_type == "delivery_address" && !this.$CoreSettingsJs.emptyObjectValidation(this.skip_display)) {
					return (!this.$CoreSettingsJs.emptyObjectValidation(this.data) &&
						((typeof this.data == "object" && this.data.includes(item[this.value_key])) || (typeof this.data != "object" && this.data == item[this.value_key]))) ||
						((this.$CoreSettingsJs.emptyObjectValidation(item["warehouse_ids"]) ||
							(!this.$CoreSettingsJs.emptyObjectValidation(item["warehouse_ids"]) &&
								!this.$CoreSettingsJs.emptyObjectValidation(this.skip_display["warehouse_id"]) &&
								item["warehouse_ids"].includes(this.skip_display["warehouse_id"]))) &&
							(this.$CoreSettingsJs.emptyObjectValidation(item[this.status_key]) ||
								(this.inc_inactive && parseInt(item[this.status_key]) == 0) ||
								(parseInt(item[this.status_key]) != 0 && parseInt(item[this.status_key]) != 2)))
						? true
						: false;
				} else if (!this.$CoreSettingsJs.emptyObjectValidation(this.ignore_value) && this.ignore_value.includes(item[this.value_key])) {
					return false;
				} else {
					if (!this.$CoreSettingsJs.emptyObjectValidation(item[this.status_key]) && parseInt(item[this.status_key]) == 1) {
						return true;
					}

					// Otherwise apply existing filters
					return this.$CoreSettingsJs.emptyObjectValidation(item[this.status_key]) ||
						(this.inc_inactive && parseInt(item[this.status_key]) == 0) ||
						![0, 2].includes(parseInt(item[this.status_key])) ||
						(!this.$CoreSettingsJs.emptyObjectValidation(this.data) &&
							((typeof this.data == "object" && this.data.includes(item[this.value_key])) || (typeof this.data != "object" && this.data == item[this.value_key])))
						? true
						: false;
				}
			},
			name(item) {
				return item[this.text_key];
			},
			status(item) {
				return item[this.status_key];
			},
			tooltip(item) {
				return item[this.tooltip_key];
			},
		},
	};
</script>
